import * as yup from "yup";
export const schema = yup.object().shape({
  accountHolderId: yup
    .number()
    .required("Account holder required")
    .moreThan(-1, "Account holder required"),
  bankName: yup.string().when("showBankAndCountry", {
    is: true,
    then: (schema) => schema.required("Bank name required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  country: yup.string().when("showBankAndCountry", {
    is: true,
    then: (schema) => schema.required("Country required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  accountNameMatches: yup.string().oneOf(["yes", "no"]).required("Field required"),
  bankAccountName: yup.string().when("accountNameMatches", {
    is: "no",
    then: (schema) => schema.required("Bank account name required"),
  }),
  explanation: yup.string().when("accountNameMatches", {
    is: "no",
    then: (schema) => schema.required("Explanation required"),
  }),
  accountHolderType: yup.string().when("accountHolderId", {
    is: 0,
    then: (schema) =>
      schema.oneOf(["individual", "institution"]).required("Account holder type required"),
  }),
  accountHolderFirstName: yup.string().when(["accountHolderId", "accountHolderType"], {
    is: (accountHolderId: number, accountHolderType: string) =>
      accountHolderId === 0 && accountHolderType === "individual",
    then: (schema) => schema.required("First name required"),
  }),
  accountHolderMiddleName: yup.string(),
  accountHolderLastName: yup.string().when(["accountHolderId", "accountHolderType"], {
    is: (accountHolderId: number, accountHolderType: string) =>
      accountHolderId === 0 && accountHolderType === "individual",
    then: (schema) => schema.required("Last name required"),
  }),
  accountHolderLegalName: yup.string().when(["accountHolderId", "accountHolderType"], {
    is: (accountHolderId: number, accountHolderType: string) =>
      accountHolderId === 0 && accountHolderType === "institution",
    then: (schema) => schema.required("Legal name required"),
  }),
  showBankAndCountry: yup.boolean(),
});
